(function (app) {

    app.provider("marketingTrackerEmailMarketingApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.getMetricsByYear = function (year) {
                            return marketingTrackerApiGateway.get("/EmailMarketing/MetricsByYear?year=" + year,
                                {
                                    params: {
                                        year: year
                                    }
                                });
                        };
                        service.getMetricsByTimeframe = function (startDate, endDate) {
                            return marketingTrackerApiGateway.get("/EmailMarketing/Metrics?startDate=" + startDate + "&endDate=" + endDate,
                                {
                                    params: {
                                        startDate: startDate,
                                        endDate: endDate
                                    }
                                });
                        };
                        service.getMetricsByMonth = function (year, month) {
                            return marketingTrackerApiGateway.get("/EmailMarketing/MetricsByMonth?year=" + year + "&month=" + month,
                                {
                                    params: {
                                        year: year,
                                        month: month
                                    }
                                });
                        };

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line